export default "__VITE_ASSET__yJmW9pvz__"